import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import { SURFACE_GRAIN } from '../surfaceGrain.js';
import styles from './PageShell.module.css';

export type PageShellProps = {
  header: ReactNode;
  children: ReactNode;
  className?: string;
  /** When set, applied to the page `<main>` for skip links / programmatic focus (a11y). */
  contentId?: string;
};

export function PageShell({ header, children, className, contentId }: PageShellProps) {
  return (
    <div className={cx(styles.root, SURFACE_GRAIN.default)} data-wp-page-shell="">
      <header className={styles.header} data-wp-shell-header="">
        <div className={styles.headerInner}>{header}</div>
      </header>
      <main
        className={cx(styles.main, contentId && 'wp-focus-visible', className)}
        data-wp-mist-scroll=""
        id={contentId}
        tabIndex={contentId ? -1 : undefined}
      >
        {/* Sole vertical scrollport for detail routes; list pages lock via viewportLock. */}
        <div className={styles.outletFrame} data-wp-outlet-frame="">
          {children}
        </div>
      </main>
    </div>
  );
}
